import axios from 'axios';
import { getAuth } from 'firebase/auth';

import { REST_API_PATH } from '@/lib/constants';

export const http = axios.create({
  baseURL: REST_API_PATH,
});

// Bare client for the `/public/*` endpoints the unauthenticated share-link page
// calls. Deliberately has no interceptors: it must not attach `x-jwt`, and it
// must not run the 401 -> `/logout` redirect below (that endpoint answers 404,
// and a public page has no session to recover).
export const publicHttp = axios.create({
  baseURL: REST_API_PATH,
});

http.interceptors.request.use(
  async (config) => {
    const auth = getAuth();

    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken();
      // The API's FirebaseAuth security scheme is an apiKey header named
      // "x-jwt" (see securityDefinitions in the swagger spec) — not a
      // standard "Authorization: Bearer" header.
      config.headers['x-jwt'] = token;
    }

    return config;
  },
  (error) => Promise.reject(error),
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const shouldRedirect = !['/', '/logout'].includes(window.location.pathname);

    if (error.response?.status === 401 && shouldRedirect) {
      window.location.href = '/logout';
    }

    return Promise.reject(error);
  },
);
